import ApiService from "@/services/api.service";
import JwtService from "../jwt.service";

const route = 'teams';

const teams = {
    get(_id, branch_id) {
        return new Promise((resolve, reject) => {
            if (branch_id !== undefined && branch_id != 0) {
                ApiService.getAxiosInstance().defaults.headers.common['BranchId'] = branch_id;
            }

            ApiService.get(route, _id).then(({ data }) => {
                ApiService.getAxiosInstance().defaults.headers.common['BranchId'] = `${JwtService.getBranchId()}`
                resolve(data);
            }, (error) => {
                ApiService.getAxiosInstance().defaults.headers.common['BranchId'] = `${JwtService.getBranchId()}`;
                reject(error);
            });
        });
    },
    add(_module) {
        return new Promise((resolve, reject) => {
            ApiService.post(route, _module).then(({ data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    edit(_id, _module) {
        return new Promise((resolve, reject) => {
            ApiService.patch(route, _id, _module).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    rem(_id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(route, _id)
                    .then(({ data }) => {
                        resolve(data);
                    }, (error) => {
                        reject(error);
                    });
        });
    }
};

export default teams;